export interface DictionaryFuelPriceIndexRecord {
    id: number;
    name: string;
    symbol: string;
    fcaUpdateTimestamp: Date;
    plattsUpdateTimestamp: Date;
    assessDate: Date;
    indexValueDaily: number;
    indexValueWeeklyMonday: number;
    indexValueWeeklyTuesday: number;
    indexValueWeeklyBiweekly: number;
    indexValueMonthly: number;
    uom1: string;
    uom2: string;
}
